import { render, staticRenderFns } from "./about.vue?vue&type=template&id=29d6cc53&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29d6cc53')) {
      api.createRecord('29d6cc53', component.options)
    } else {
      api.reload('29d6cc53', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=29d6cc53&", function () {
      api.rerender('29d6cc53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/about.vue"
export default component.exports